<template>
  <div class="courseDards">
    <div class="items">
      <div class="item" v-for="(item, index) in data" :key="index">
        <div class="topTit" v-html="item.title"></div>
        <div class="cont">
          <div class="des" v-html="item.desc"></div>
          <div v-if="item.objList">
            <div class="tit">配套项目</div>
            <div class="list" v-for="(it, ind) in item.objList" :key="ind">
             <img :src="it.icon"  class="icon" alt=""> 
             <div>{{ it.name }}</div>
            </div>
          </div>
        </div>
        <div class="bot"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      default: [],
    },
  },
};
</script>
<style lang="scss" scoped>
.courseDards {
  width: 1182px;
  margin: 0 auto;
  .items {
    display: flex;
    justify-content: space-between;
    .item {
      width: calc(20% - 15px);
      background: #ffffff;
      box-shadow: 0 2px 50px 0 #555b9214;
      border-radius: 4px;
      .topTit {
        background-color: #1086FF;
        border-radius: 4px 4px 0 0;
        border-radius: 4px 4px 0 0;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        height: 72px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
      }
      .cont {
        padding: 20px;
        height: 240px;
        .des {
          font-size: 14px;
          height: 130px;
          line-height: 24px;
          color: #616a72;
        }
        .tit {
          text-align: center;
          color: #1086ff;
          line-height: 24px;
        }
        .list {
          text-align: center;
          color: #616a72;
          line-height: 20px;
          display: flex;
          align-items: flex-start;
          div{
            text-align: left;
          }
          .icon{
            width: 18px;
            position: relative;
            margin-right: 4px;
          }
        }
      }
      .bot {
        height: 10px;
        transform: scaleY(-1);
        background-image: linear-gradient(270deg, #ededfd 0%, #d6e7fb 100%);
        border-radius: 4px 4px 0 0;
        border-radius: 4px 4px 0 0;
      }
    }
  }
}
</style>
